var _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumberTwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "url(#paint0_linear_1263_628)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.462 18V15.718C8.504 15.69 8.63467 15.599 8.854 15.445C9.078 15.2863 9.34633 15.0927 9.659 14.864C9.97633 14.6353 10.3053 14.395 10.646 14.143C10.9867 13.891 11.2993 13.6577 11.584 13.443C11.9107 13.1957 12.2257 12.939 12.529 12.673C12.837 12.407 13.089 12.127 13.285 11.833C13.4857 11.5343 13.586 11.217 13.586 10.881C13.586 10.5263 13.4973 10.2277 13.32 9.985C13.1473 9.73767 12.8603 9.614 12.459 9.614C12.1323 9.614 11.8757 9.68867 11.689 9.838C11.507 9.98733 11.3787 10.195 11.304 10.461C11.2293 10.7223 11.192 11.028 11.192 11.378H8.364C8.364 10.566 8.52733 9.87067 8.854 9.292C9.18533 8.71333 9.659 8.27 10.275 7.962C10.8957 7.654 11.6377 7.5 12.501 7.5C13.369 7.5 14.0923 7.654 14.671 7.962C15.2543 8.27 15.6907 8.683 15.98 9.201C16.2693 9.71433 16.414 10.2837 16.414 10.909C16.414 11.343 16.33 11.7397 16.162 12.099C15.9987 12.4537 15.784 12.778 15.518 13.072C15.2567 13.3613 14.9767 13.6227 14.678 13.856C14.384 14.0893 14.104 14.3017 13.838 14.493C13.3853 14.815 13.012 15.081 12.718 15.291C12.424 15.4963 12.1977 15.6527 12.039 15.76C11.885 15.8673 11.787 15.935 11.745 15.963H16.267V18H8.462Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1263_628",
    x1: 10.7798,
    y1: -0.00000233067,
    x2: 21.87,
    y2: 6.0596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#446DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F5DFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberTwo);
export default __webpack_public_path__ + "static/media/numberTwo.8182a7d52c0a48068f92d9579a5d8dc2.svg";
export { ForwardRef as ReactComponent };